module.exports = __webpack_public_path__ + "static/media/26_plantilla_navidad_combo_simple_y_duo_rec_fondo_motivo_2.bf1a95c3.png";